export enum AttendanceStatus{
    None = 0,
    Attended = 1,
    LateArrival = 2,
    LateEarly  = 3,
    NoShow = 4,
    NoReply = 5,
    Sick = 6,
    Vacation = 7,
    UnitOvertime = 8
}